import apiClient from '@/shared/api/client';
import type { ApiResponse } from '@/shared/api/types';

/** One saved row of the practice's new-patient counts (backend practiceOutcomes.service.ts). */
export interface AdOutcomeRow {
  periodStart: string;
  periodEnd: string;
  /** The campaign label as entered; `matchedCampaign` is the campaign it was matched to, by name. */
  campaign: string;
  matchedCampaign: string | null;
  callersMatched: number | null;
  newPatientHouseholds: number | null;
  newPatients: number | null;
  source: string;
}

export interface AdOutcomes {
  outcomes: AdOutcomeRow[];
  /** The campaigns this location's ads reads count, to enter counts against. */
  campaigns: Array<{ name: string; platform: string }>;
}

export interface AdOutcomesInput {
  periodStart: string;
  periodEnd: string;
  rows: Array<{
    campaign: string;
    callersMatched?: number | null;
    newPatientHouseholds?: number | null;
    newPatients?: number | null;
  }>;
}

interface SaveResult {
  saved: number;
  matchedToCampaign: number;
  unmatchedLabels: string[];
}

const base = (practiceId: string, locationId: string) =>
  `/agency/practices/${practiceId}/locations/${locationId}/ad-outcomes`;

export const adOutcomesApi = {
  get: async (practiceId: string, locationId: string): Promise<AdOutcomes> => {
    const { data } = await apiClient.get<ApiResponse<AdOutcomes>>(base(practiceId, locationId));
    return data.data;
  },

  save: async (
    practiceId: string,
    locationId: string,
    input: AdOutcomesInput,
  ): Promise<SaveResult> => {
    const { data } = await apiClient.post<ApiResponse<SaveResult>>(
      base(practiceId, locationId),
      input,
    );
    return data.data;
  },
};
